import { formatCurrency } from '@smarttransit/common'

function toCents (val) {
  const parsed = parseFloat((val || '').toString().replace(/[,\s]/g, ''))
  return Number.isNaN(parsed) ? null : Math.round(parsed * 100)
}

function toDollarString (cents) {
  return (cents === null || cents === undefined || cents === '') ? '' : formatCurrency(cents, null, '0.00')
}

export default {
  name: 'currency-field',
  props: {
    childProps: Object,
    value: [String, Number] // value must be in cents
  },
  data () {
    return {
      rawInput: '',
      focused: false
    }
  },
  computed: {
    prefix () {
      return this.$props.childProps && this.$props.childProps.prefix ? this.$props.childProps.prefix : ''
    },
    fieldLabel () {
      return this.$props.childProps && this.$props.childProps.label ? this.$props.childProps.label : ''
    },
    hasLabelContent () {
      return Boolean(this.fieldLabel || this.previewLabel)
    },
    trimmedInput () {
      return (this.$data.rawInput || '').toString().trim()
    },
    formatError () {
      const value = this.trimmedInput

      if (!value) {
        return null
      }

      if (/[^0-9.,\s]/.test(value)) {
        return 'Only numbers and a single decimal point are allowed'
      }

      if ((value.match(/\./g) || []).length > 1) {
        return 'Enter only one decimal point'
      }

      const decimals = value.split('.')[1]

      if (decimals && decimals.replace(/[,\s]/g, '').length > 2) {
        return 'Only two decimal places (cents) are allowed'
      }

      return null
    },
    previewLabel () {
      if (!this.trimmedInput || this.formatError) {
        return ''
      }

      return (this.prefix ? this.prefix + ' ' : '') + toDollarString(toCents(this.trimmedInput))
    },
    computedErrorMessages () {
      const messages = this.formatError ? [this.formatError] : []
      const childProps = this.$props.childProps || {}
      const provided = childProps.errorMessages || childProps['error-messages']

      return provided ? messages.concat(provided) : messages
    },
    computedHideDetails () {
      const childProps = this.$props.childProps || {}
      const hideDetails = childProps.hideDetails !== undefined ? childProps.hideDetails : childProps['hide-details']

      return this.formatError ? false : hideDetails
    }
  },
  watch: {
    value (val) {
      if (!this.$data.focused) {
        this.$data.rawInput = toDollarString(val)
      }
    }
  },
  mounted () {
    this.$data.rawInput = toDollarString(this.$props.value)
  },
  methods: {
    currentCents () {
      return (this.formatError || !this.trimmedInput) ? null : toCents(this.trimmedInput)
    },
    onInput (val) {
      this.$data.rawInput = val
      this.$emit('input', this.currentCents())
    },
    onFocus () {
      this.$data.focused = true
    },
    onBlur () {
      this.$data.focused = false
      const cents = this.currentCents()

      if (cents !== null) {
        this.$data.rawInput = toDollarString(cents)
      }

      this.$emit('input', cents)
      this.$emit('blur', cents)
    },
    onClick () {
      this.$emit('click', this.currentCents())
    }
  }
}
